<style type="text/css" media="screen">


.warehouse-select{
	font-size: 12px !important
}


</style>

<template>
	<div>
		<v-combobox
		v-model="warehouse"
		:items="warehouse_list"
		item-text="name"
		item-value="id"
		:label="$lang.WAREHOUSE"
		@focus="warehouseAutoComplete"
		@keydown="warehouseAutoComplete"
		@change="updateWarehouse"
		:search-input.sync="warehouse_serch_query"
		append-icon="mdi-menu-down"
		single-line
		outlined
		:clearable="false"
		dense
		:rules="$rules.WAREHOUSE"
		:loading="loading"
		class="warehouse-select"
		>
		<template v-slot:item="data">
			<v-list-item-content>
				<v-list-item-title v-html="data.item.name"></v-list-item-title>
				<v-list-item-subtitle >{{data.item.city}},{{data.item.state}}</v-list-item-subtitle>
			</v-list-item-content>
		</template>

	</v-combobox> 		
</div>
</template>
<script type="text/javascript">

export default {
	props:{
		set_default:{
			type: Boolean,
			default:false
		}

	},
	data () {
		return {
			warehouse:null,
			loading:false,	
			warehouse_list:[],
			warehouse_serch_query:"",
			selected_warehouse:null
		}
	},

	methods:{
		updateWarehouse(){
			this.$emit("get-warehouse",this.warehouse)
		},
		warehouseAutoComplete(){
			const self=this
			let params={
				"search_query":self.warehouse_serch_query,
			};
			self.loading=true;
			const successHandler = (response) => {
				console.log(response)
				self.warehouse_list=response.data.warehouse_list
			};
			const finallyHandler = () => {
				self.loading=false
			};
			self.request_GET( self,self.$urls.WAREHOUSE_LIST,params,successHandler,null,null,finallyHandler)


		}
	}
}
</script>